module.exports = __webpack_public_path__ + "img/arrow-r.c2d7bc4e.svg";